import { useSelector } from 'react-redux'
import { ReactComponent as MiniDivisionBadge } from '../../../../assets/images/common/icons/mini-division-badge.svg'
import { ReactComponent as StandaloneLogo } from '../../../../assets/images/common/icons/standalone-logo.svg'
import { DATETIME_FORMAT, getMomentInCommunityTimezoneReversed } from '../../../../utility/datesHelper'
import { yardageByLevel, levelColors } from '../../../../utility/curriculumHelper'
import { splitArray } from '../../../../utility/arrayHelper'
import moment from 'moment'

import classes from './AlphaReport.module.scss'
import classNames from 'classnames'

const AlphaReport = () => {
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)
  const event = useSelector(state => state.nineHoleEvent)
  const startTime = getMomentInCommunityTimezoneReversed(moment(event.eventDate), timezone, DATETIME_FORMAT)

  const filteredStudents = [...event.students]
    .filter((s) => !!s.pairingGroupId)
    .toSorted((a, b) =>
      a.lastName?.toLowerCase().localeCompare(b.lastName?.toLowerCase())
    )

  const groupedStudents = splitArray(filteredStudents, 16)

  return (
    <div id='alpha' className={classes.alphaReport}>
      {groupedStudents.map((students, index) => (
        <div key={index} className='PairingsAlphaTeeSheetPage p-4'>
          <div className='d-flex justify-content-between w-100'>
            <div className={classes.title}>
              Alpha List - {event.name}
            </div>
            <StandaloneLogo className={classes.logo}/>
          </div>

          <div className={classes.date}>
            {startTime.format('MMM D, YYYY h:mma')} - {startTime.clone().add(1, 'hours').format('h:mma')}
          </div>
          <div className={classes.header}>
            <div className={classes.startTime}>Time</div>
            <div className={classes.hole}>Hole</div>
            <div className={classes.yardage}>Yardage</div>
            <div className={classes.players}>Player</div>
          </div>
          {students.map((student) => {
            const group = event.pairings.pairingGroups.find((group) => group.id === student.pairingGroupId)
            return (
              <div
                key={student.id}
                className={classes.studentRow}
              >
                <div className={classes.startTime}>
                  {getMomentInCommunityTimezoneReversed(
                    moment(group?.startTime),
                    timezone,
                    DATETIME_FORMAT
                  ).format('LT')}
                </div>
                <div className={classes.hole}>
                  { `${group?.startHole.value || ''} ${group?.playersGroup.value || ''}` }
                </div>

                <div className={classes.yardage}>
                  {student.level < 6 ? yardageByLevel[student.level] / 9 + ' yds' : 'Full Tee Box'}
                </div>
                <div className={classes.players}>
                  <div className='d-flex flex-wrap'>
                    <div
                      className={classNames(
                        'd-flex align-items-center px-1',
                        classes.studentWrapper
                      )}
                      key={student.id}
                    >
                      <MiniDivisionBadge fill={levelColors[student.level]} className={classes.levelBadge}/>
                      <div className={classes.studentLevel} style={{ color: levelColors[student.level] }}>{student.level}</div>
                      <p className={classes.studentName}>
                        {student.firstName} {student.lastName}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      ))}

    </div>
  )
}

export default AlphaReport
